var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splash-screen"},[_c('transition',{attrs:{"name":"fade-animate","enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[_c('div',{staticClass:"splash-screen-cover"},[_c('img',{attrs:{"src":require("../assets/images/logo.svg"),"alt":"Kidjo"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }